<template>
  <div class="checkout">
    <span class="overview">會員資料</span>
    <v-row class="information py-3" no-gutters>
      <v-col cols="12" sm="5" md="4">
        <div>
          <span class="mr-5">姓名:</span>{{ user.last_name }}{{ user.first_name }}
        </div>
        <div>
          <span>Email: </span>{{ user.email }}
        </div>
      </v-col>
      <v-col>
        <div><span>手機號碼: </span>{{ user.tel }}</div>
      </v-col>
    </v-row>

    <div class="store mt-8">
      <span class="overview">超商門市選擇</span>
      <form class="d-inline-block" method="POST" :action="mapUrl">
        <v-btn dark small class="ml-10" type="submit">選擇門市</v-btn>
      </form>
      <div class="py-2">
        <v-row no-gutters>
          <v-col class="d-flex align-center my-2 pr-4" cols="12" sm="6">
            <span>門市編號</span>
            <v-text-field 
              outlined 
              readonly
              filled 
              height="30"
              class="ml-2"
              v-model="shop.id"
            ></v-text-field>
          </v-col>
          <v-col class="d-flex align-center my-2 pr-4" cols="12" sm="6">
            <span>門市名稱</span>
            <v-text-field 
              outlined 
              readonly
              filled 
              height="30"
              class="ml-2"
              v-model="shop.name"
            ></v-text-field>
          </v-col>
        </v-row>
        <div class="d-flex align-center mt-2 pr-4">
          <span>門市地址</span>
          <v-text-field 
            outlined 
            readonly
            filled 
            height="30"
            class="ml-2"
            v-model="shop.address"
          ></v-text-field>
        </div>
      </div>
    </div>

    <div class="recipient mt-8">
      <span class="overview">收件人</span>
      <v-btn dark small class="ml-10" @click="setAsMemberData">同會員資料</v-btn>
      <div class="py-2">
        <v-row no-gutters>
          <v-col class="d-flex align-center my-2 pr-4" cols="12" sm="6">
            <span>姓名</span>
            <v-text-field 
              outlined 
              height="30"
              class="ml-2"
              v-model="recipient.name"
              :rules="[$rules.notEmpty]"
            ></v-text-field>
          </v-col>
          <v-col class="d-flex align-center my-2 pr-4" cols="12" sm="6">
            <span>手機</span>
            <v-text-field 
              outlined 
              height="30"
              class="ml-2"
              v-model="recipient.tel"
              :rules="[$rules.integer]"
            ></v-text-field>
          </v-col>
        </v-row>
        <div class="d-flex align-center mt-2 pr-4">
          <span>Email</span>
          <v-text-field 
            outlined 
            height="30"
            class="ml-2"
            v-model="recipient.email"
            :rules="[$rules.email]"
          ></v-text-field>
        </div>
      </div>
    </div>
    
    <v-divider class="mt-4"></v-divider>

    <div class="cart-detail">
      <div class="amount">
        <div>
          <span>商品</span>
          <span class="d-flex align-center">
            {{ selectedPrice }}
          </span>
        </div>
        <div>
          <span>運費</span>
          <span class="d-flex align-center">
            {{ shop.id ? shippingFee : '待計算' }}
          </span>
        </div>
        <div class="total">
          <span>合計</span>
          <span class="d-flex align-center">
            <div class="peach"></div>
            {{ selectedPrice + shippingFee }}
          </span>
        </div>
      </div>
      <div class="cart-action">
        <v-btn outlined class="black--text" to="/shoppingcart/payment">上一步</v-btn>
        <v-btn color="black white--text" @click="formIsValid ? (!user.email_verified ? $root.$emit('confirmDialog', checkout, '請確認Email已被驗證<br>相關郵件將寄至您的Email', '  fas fa-envelope') : checkout()) : ''">立即付款</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
  created() {
    if(this.$route.query.error && this.$route.query.error == '1') {
        this.$root.$emit('errorDialog', ['取得商店資訊失敗，請稍後再試一次。'])
    }
    this.$store.dispatch('shoppingCart/getShoppingCartProducts')
  },
  computed: {
    ...mapState('user', ['user']),
    ...mapState('shoppingCart', ['recipient', 'shop', 'token']),
    ...mapGetters('shoppingCart', ['totalNumOfSelectedProducts', 'selectedPrice', 'selectedProducts', 'shippingFee']),
    mapUrl() {
      return `https://logistics.ecpay.com.tw/Express/map?MerchantID=${process.env.VUE_APP_MerchantID}&LogisticsType=CVS&LogisticsSubType=${this.$store.state.shoppingCart.shipping}&IsCollection=N&ServerReplyURL=${process.env.VUE_APP_API}/member/map&ExtraData=${this.token}`
    },
    formIsValid() {
      return (
        this.$rules.notEmpty(this.recipient.name) && 
        this.$rules.integer(this.recipient.tel) && 
        this.$rules.email(this.recipient.email) &&
        this.$rules.notEmpty(this.shop.id) &&
        this.$rules.notEmpty(this.shop.name) &&
        this.$rules.notEmpty(this.shop.address)
      )
    }
  },
  methods: {
    setAsMemberData() {
      this.recipient.name = `${this.user.last_name}${this.user.first_name}`
      this.recipient.tel = this.user.tel
      this.recipient.email = this.user.email
    },
    checkout() {
      if(!this.formIsValid) {
        return
      }
      this.$root.$emit('loading', true)
      this.axios.post('/member/checkout', {
        name: this.recipient.name,
        tel: this.recipient.tel,
        email: this.recipient.email,
        token: this.token
      }).then(response => {
        this.$store.dispatch('shoppingCart/setLastOrderPrice', this.selectedPrice + this.shippingFee)
        this.$store.dispatch('user/getUserInformation')
        this.$store.dispatch('shoppingCart/getShoppingCartProducts', {
          setShop: false
        })
        this.$router.push('/shoppingcart/success')
      }).catch(e => {
        if(e.response.data.message.includes('There are products in the request sold')) {
          this.router.push('/shoppingcart')
          this.$root.$emit('errorDialog', ['您所選購的商品已售出。請重新選購。'])
        }
      }).finally(() => {
        this.$root.$emit('loading', false)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.checkout {
  .information {
    line-height: 1.8;
    span {
      margin-right: 8px;
    } 
  }
  .store, .recipient {
    max-width: 600px;
    span {
      white-space: nowrap;
    }
  }
  .v-input {
    .v-input__slot {
      min-height: unset;
      margin-bottom: 0;
    }
    .v-text-field__details {
      display: none;
    }
  }
}
</style>